module.exports = __webpack_public_path__ + "img/check-circle-regular.c1f8074b.svg";